export default __webpack_public_path__ + "static/media/arduino.51319eb1.png";